import { ChangeDetectionStrategy, Component, Input, OnInit, inject } from '@angular/core';
import { IFiltersOptionsParam } from 'src/app/data/store/models/filters.model';
import { IUser } from '../../services/user/user.type';
import { UtilsService } from '../../services/utils.service';
import { EmployeesPageType, FiltersModalType } from '../../enums';
import { Store } from '@ngrx/store';
import {
  clearDepartmentsList,
  getEmployeesList,
} from '../../../data/store/actions/department.action';
import { Observable } from 'rxjs';
import {
  selectAllDepartmentListIsFetched,
  selectDepartmentListIsLoading,
  selectDepartmentsList,
} from '../../../data/store/selectors/department.selectors';
import { selectFiltersState } from '../../../data/store/selectors/filters.selectors';
import { noDataText } from '../../constants';
import { setFiltersOptions } from 'src/app/data/store/actions/filters.actions';
import { SearchBarWithFiltersComponent } from '../search-bar-with-filters/search-bar-with-filters.component';
import { AsyncPipe } from '@angular/common';
import { PaginationContainerComponent } from '../pagination-container/pagination-container.component';
import { EmployeeCardComponent } from '../employee-card/employee-card.component';
@Component({
  selector: 'app-common-employees-list',
  templateUrl: './common-employees-list.component.html',
  styleUrls: ['./common-employees-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    SearchBarWithFiltersComponent,
    PaginationContainerComponent,
    EmployeeCardComponent,
    AsyncPipe,
  ],
})
export class CommonEmployeesListComponent implements OnInit {
  utils = inject(UtilsService);
  private _store = inject(Store);

  @Input() id: number | null = null;

  @Input() director: IUser | null = null;

  @Input() currentEmployeesPageType: EmployeesPageType = EmployeesPageType.additionalEmployees;

  employeesList$: Observable<IUser[]> = this._store.select(selectDepartmentsList);

  public isLoading$: Observable<boolean> = this._store.select(selectDepartmentListIsLoading);

  public filtersState$ = this._store.select(selectFiltersState);

  public isAllEmployeesListFetched$: Observable<boolean | null> = this._store.select(
    selectAllDepartmentListIsFetched,
  );

  public readonly employeesPageType = EmployeesPageType;

  public readonly filtersModalType = FiltersModalType.employeesList;

  public isShowDirector = true;

  public filtersOptionsParams: IFiltersOptionsParam = {
    DEPTS: { order: 1, params: null },
    GROUPS: { order: 2, params: null },
    REGIONS: { order: 3, params: null },
    SHOPS: { order: 4, params: null },
  };

  public noDataText: string = noDataText;

  @Input() listName?: string;

  public clearList = clearDepartmentsList();

  ngOnInit(): void {
    if (this.currentEmployeesPageType === EmployeesPageType.allEmployees) {
      this._store.dispatch(
        setFiltersOptions({
          filtersOption: this.filtersOptionsParams ?? null,
        }),
      );
    }
    this.getEmployees();
  }

  public getEmployees(query?: string | null) {
    this.isShowDirector = [this.director?.firstName, this.director?.lastName]
      .join(' ')
      ?.toLowerCase()
      ?.includes(query?.toLowerCase() || '');

    this._store.dispatch(
      getEmployeesList({
        departmentId: this.id,
        currentEmployeesPageType: this.currentEmployeesPageType,
      }),
    );
  }

  public trackByFn(index: number, obj: IUser) {
    return obj.id;
  }
}
